import React from 'react';
import { VendorEntity } from '../../models';

interface VendorDetailContextType {
  vendor: VendorEntity | null;
  vendorId: number;
}

export const VendorDetailContext = React.createContext<VendorDetailContextType>({} as VendorDetailContextType);
